export default "__VITE_ASSET__b806c785__"